var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex col-grow no-wrap"},[_c('menu-cadastro-basico',{attrs:{"active":_vm.active}}),_c('div',{staticClass:"app-layout-cmenu",staticStyle:{"padding-right":"0"}},[_c('transition',{attrs:{"name":"slide","appear":""}},[_c('div',{staticClass:"transition-generic"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }